import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['rows', 'template']

  connect () {
    console.log('rec loaded')
    this.index = this.rowsTarget.children.length
  }

  addRow () {
    const html = this.templateTarget.innerHTML.replaceAll('INDEX', this.index)

    this.rowsTarget.insertAdjacentHTML('beforeend', html)
    this.index += 1
  }

  removeRow (event) {
    event.currentTarget.closest('[data-reconciliation-row]').remove()
  }
}
